import React from 'react';
import classNames from 'classnames';

interface CookieBannerProps {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onCustomize: () => void;
  onClose: () => void;
}

const CookieBanner: React.FC<CookieBannerProps> = ({
  onAcceptAll,
  onRejectAll,
  onCustomize,
  onClose
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-main-gray shadow-lg">
      <div className="land-container py-4">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          {/* Content */}
          <div className="flex-1 pr-4">
            <h3 className="text-main-black text-lg font-medium mb-2">
              Cookie Preferences
            </h3>
            <p className="text-main-neutrals text-sm leading-relaxed">
              We use cookies to enhance your browsing experience, serve personalized content, 
              and analyze our traffic. By clicking &quot;Accept All&quot;, you consent to our use of cookies. 
              You can manage your preferences or learn more in our{' '}
              <a 
                href="/privacy-policy" 
                className="text-main-blue hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>.
            </p>
          </div>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-2 lg:flex-shrink-0">
            <button
              onClick={onCustomize}
              className="px-4 py-2 text-main-blue border border-main-blue rounded hover:bg-main-blue hover:text-white transition-colors text-sm font-medium"
            >
              Customize
            </button>
            <button
              onClick={onRejectAll}
              className="px-4 py-2 text-main-neutrals border border-main-gray rounded hover:bg-main-gray transition-colors text-sm font-medium"
            >
              Reject All
            </button>
            <button
              onClick={onAcceptAll}
              className="px-4 py-2 bg-main-blue text-white rounded hover:bg-opacity-90 transition-colors text-sm font-medium"
            >
              Accept All
            </button>
          </div>
        </div>
        
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-2 text-main-neutrals hover:text-main-black transition-colors"
          aria-label="Close cookie banner"
        >
          <svg 
            width="12" 
            height="12" 
            viewBox="0 0 12 12" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M11 1L1 11M1 1L11 11" 
              stroke="currentColor" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
